import React from 'react';

import { BaseMeasures } from './BaseMeasures.ts';

export enum WATERFALL_INITIAL_MEASURES {
	CSS_MAIN = 'wf/css/main',
	CSS_SUPERBATCH = 'wf/css/superbatch',
	CSS_CONNECT_WEB_RESOURCES = 'wf/css/connectWebResources',
	CSS_COMPILED = 'wf/css/compiled',
	JS_SUPERBATCH = 'wf/js/superbatch',
	JS_CONNECT_WEB_RESOURCES = 'wf/js/connectWebResources',
	HTML_THEME_INIT = 'wf/html/themeInit',
	HTML_REACT_ROOT = 'wf/html/reactRoot',
	HTML_SSR_SCRIPTS = 'wf/html/ssrScripts',
	HTML_SUSPENSE = 'wf/html/suspense',
	HTML_FORCE_LAYOUT = 'wf/html/forceLayout',
	SSR_GLOBALS = 'wf/html/ssrGlobals',
	SSR_ERROR_GLOBALS = 'wf/html/ssrErrorGlobals',
	STATSIG_BOOTSTRAP = 'wf/html/statsigBootstrap',
	FFP_BOOTSTRAP = 'wf/html/ffpBootstrap',
	SSR_BEFORE_SCRIPTS = 'wf/bootstrap/ssrBeforeScripts',
	SSR_AFTER_SCRIPTS = 'wf/bootstrap/ssrAfterScripts',
	CREATE_APOLLO_CLIENTS = 'wf/bootstrap/createApolloClients',
	BOOTSTRAP_SESSION_DATA = 'wf/bootstrap/getSessionData',
	BOOTSTRAP_TRANSLATION = 'wf/bootstrap/loadTranslation',
	BOOTSTRAP_LOADABLE = 'wf/bootstrap/preloadLoadable',
	BOOTSTRAP_INITIALIZE_STORAGE_MANAGER = 'wf/bootstrap/initializeStorageManager',
	BOOTSTRAP_INITIALIZE_COOKIES = 'wf/bootstrap/initializeCookies',
}

export const SERVER_TIMING_MEASURES: string[] = [
	'atl-edge-internal',
	'atl-edge-upstream',
	'cdn-upstream-fbl',
	'cdn-upstream-dns',
	'cdn-upstream-connect',
	'cdn-downstream-fbl',
];

export function perfMark(name: string): React.JSX.Element | null {
	const nonceValue = window.__SSR_NONCE_VALUE__;
	return (
		<script
			{...(nonceValue !== undefined ? { nonce: nonceValue } : {})}
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{
				__html: `window.__SSR_RENDERED__&&window.performance.mark("${name}")`,
			}}
		/>
	);
}

class WaterfallMeasure extends BaseMeasures {
	private markedKeys = new Set<string>();

	override markMeasureStart(name: string, timestamp?: number): void {
		this.markedKeys.add(name);
		window.performance.clearMarks(`${name}.start`);
		window.performance.mark(`${name}.start`, {
			startTime: Math.floor(timestamp ?? performance.now()),
		});
	}

	override markMeasureEnd(name: string, timestamp?: number): void {
		window.performance.clearMarks(`${name}.end`);
		window.performance.mark(`${name}.end`, {
			startTime: Math.floor(timestamp ?? performance.now()),
		});
	}

	getMeasureKeys(after: number): string[] {
		return Array.from(this.markedKeys).filter((key) => {
			const mark = performance.getEntriesByName(`${key}.start`, 'mark');
			return mark.length && mark[0].startTime >= after;
		});
	}

	override clearMeasures(): void {
		super.clearMeasures();
		this.markedKeys.clear();
	}
}

export const WaterfallMeasures: WaterfallMeasure = new WaterfallMeasure();
